module.exports = __webpack_public_path__ + "static/img/icon.e794ad8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_6/icon.jpg
// module id = 1Gt/
// module chunks = 0